/* eslint-disable max-len */
import React from 'react'
import cx from 'classnames'
import { SvgIcon } from '../svg-icon'

import styles from './end-position-icon.module.css'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <...Icon width={12} />
 */
const EndPositionIcon = props => (
    <SvgIcon {...props} className={cx(styles['end-position-pin'], 't3sel-end-position-icon')}>
        <path
            className={styles['icon-foreground']}
            d={`M37.528 7.877a19.117 19.117 0 0 0-13.51-5.56A19.107 19.107 0 0
                0 10.502 7.88a18.867 18.867 0 0 0-5.598 13.43c0 5.246 2.144 9.996 5.603 13.434C13.967 38.18 24.017 46
                24.017 46S34.07 38.18 37.53 34.74c3.46-3.438 5.598-8.185 5.598-13.43 0-5.245-2.14-9.994-5.6-13.433`}
        />
        <path
            className={styles['icon-background']}
            d={`M36.627 8.813a17.84 17.84 0 0 0-12.61-5.19 17.84 17.84 0 0
                0-12.614 5.192A17.616 17.616 0 0 0 6.178 21.35c0 4.896 2 9.33 5.23 12.54 3.228 3.206 12.608 10.505
                12.608 10.505s9.384-7.3 12.613-10.51c3.225-3.21 5.222-7.64 5.222-12.535
                0-4.896-1.997-9.328-5.227-12.537`}
        />
        <path
            className={styles['icon-foreground']}
            d={`M14.578 11.662a1 1 0 0 0-1 .998v17h2v-17a1 1 0 0 0-1-.998zm19
                0a1 1 0 0 0-1 .998v17h2v-17a1 1 0 0 0-1-.998zm-17 2h3v3h-3v-3zm3.002
                2.998h2.998v3h-3v-3zm2.998-2.998h3v3h-3v-3zm-6 5.998h3v3h-3v-3zm6
                0h3v3h-3v-3zm3.002-3h2.998v3h-3v-3zm3-2.998h2.998v3h-3v-3zm0 5.998h2.998v3h-3v-3z`}
        />
    </SvgIcon>
)

EndPositionIcon.defaultProps = defaultProps

export { EndPositionIcon }
